module.exports = __webpack_public_path__ + "img/zhly-bg.d7ec2b2a.png";